<template>
  <NuxtLink
    prefetch
    :to="$paths.home"
    class="logo"
  >
    <img
      v-if="imgSrc"
      width="100"
      height="40"
      class="logo__img"
      :class="{mini: isLoggedIn && windowWidth < 800}"
      :src="imgSrc"
      alt="logo"
    />
  </NuxtLink>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  data() {
    return {
      windowWidth: process.client ? window.innerWidth : 0,
      imgSrc: '',
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  watch: { 
    windowWidth() {
      this.updateImgSrc()
    }, 
    isLoggedIn() {
      this.updateImgSrc()
    },
  },
  mounted() {
    this.updateWidth()
    window.addEventListener('resize', this.updateWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    updateWidth() {
      this.windowWidth = window.innerWidth
      this.updateImgSrc()
    },
    updateImgSrc() {
      this.imgSrc = this.isLoggedIn && this.windowWidth < 800
        ? '/img/logo/logo-mini.svg'
        : '/img/logo/logo.svg'
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
